import { render } from "./templates/externalsku.html?vue&type=template&id=be2e4ff4&external"
import script from "./script/externalsku.js?vue&type=script&lang=js&external"
export * from "./script/externalsku.js?vue&type=script&lang=js&external"

const cssModules = {}
import style0 from "./stylesheets/index.scss?vue&type=style&index=0&lang=scss&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__